module.exports = __webpack_public_path__ + "img/happy.c4a40e83.png";